export interface AddressValue {
    address: string;
    lat: number | null;
    lng: number | null;
}

export function parseAddressValue(raw: string | undefined): AddressValue {
    if (!raw) {
        return { address: "", lat: null, lng: null };
    }
    try {
        const parsed = JSON.parse(raw);
        return {
            address: parsed.address ?? "",
            lat: parsed.lat ?? null,
            lng: parsed.lng ?? null
        };
    } catch {
        return { address: raw, lat: null, lng: null };
    }
}

export function serializeAddressValue(val: AddressValue): string {
    return JSON.stringify(val);
}
